import React, { useContext } from 'react'
import Widget from '../../../dpe-usco/components/Widget/Widget'
import Status from '.././../../components/subComponents/Status'
import moment from 'moment'
import { GlobalContext } from '../../../services/context'
import { withRouter } from 'react-router-dom'
import TableStatus from '../../../components/subComponents/TableStatus/TableStatus'
import { formatPhoneNumber } from '../../../services/utils'

export const SignersAndApprovers = ({ data, match, status, button, company_id, contractOriginated }) => {
  const { dispatch } = useContext(GlobalContext)
  const clickAnchor = (e, entry) => {
    e.preventDefault()
    const payload = {
      company_id,
      id: entry.user_id,
      title: entry.value, 
      previous: 'Back' 
    }
    dispatch({ type: 'GO_TO_USER_DETAIL', payload })
  }

  const trimPhoneNumber = number => {
    if(number && number.length > 10){
      number = number.substring(1)
    }
    number = formatPhoneNumber(number)
    return number
  }

  const renderSignersAndApprovers = () => {
    const cardContent = data.map((arrayEntry, index) => {
      const mappedArrayEntry = (
        <div  key={index}>
          <div className='mt20'>
            {
              arrayEntry.map(entry => {
                let headerFormat = 'tal fz13 c-darkgray fw600'
                let color = ''
                if(entry.contract_status === 'signed'){
                  color = 'green'
                } else if (entry.contract_status === 'awaiting signature'){
                  color = 'yellow'
                }
                return (
                  <div key={entry.id} className='df fxdrc mb10 tal'>
                    <div className='df'>
                      <div data-testid='singersData'>
                        <div className='df'>
                          <div className={headerFormat}>
                            {entry.title}
                          </div>                          
                        </div>
                        <div className='df'>
                          <div className='fz15 mb5'>
                            {entry?.user_id?.length > 15 ? <a
                              className='c-blue-500 c-blue-700:h tdu:h'
                              href={`/company/${company_id}/user/${entry.user_id}`}
                              onClick={e =>clickAnchor(e, entry)}
                            >
                              {entry.value}
                            </a>
                              :
                              <span>{entry.value}</span>
                            }
                          </div>
                        </div>                        
                      </div>
                      <div className='df ml20 mb7 aife '>
                        <Status color={color}>
                          {}
                          {(entry.signed_here && entry.contract_status === 'signed') ? `Signed through ${contractOriginated}`:entry.contract_status}
                        </Status>
                      </div>                      
                    </div>

                    {entry.delivery_choice.toLowerCase() === 'email' ? 
                      <>
                        <div className={headerFormat}>
                      Email
                        </div>
                        <div className='fz15 mb5'>
                          {entry.email?entry.email:'N/A'}
                        </div>
                      </>
                      : <>
                        <div className={headerFormat}>
                      Phone Number
                        </div>
                        <div className='fz15 mb5'>
                          {entry?.phone?trimPhoneNumber(entry.phone):null}
                        </div>

                        { entry.origPhone && entry.origPhone !== 'null' && entry.origPhone !== entry.phone && (
                          <div className={headerFormat}>
                            <div className={headerFormat}>
                          Alt. Phone Number
                            </div>
                            <div style={{ fontWeight: 'normal', color: 'black' }} className='fz15 mb5'>
                              {trimPhoneNumber(entry.origPhone)}
                            </div>
                          </div>
                        )
                        }
                      </>
                    }

                    { entry.contract_status === 'signed'
                      ?
                      <div>
                        <div className={headerFormat}>
                          {entry.title_stamp}
                        </div>
                        <div className='fz15'>
                          {moment(entry.approval_timestamp).format('MMMM Do YYYY, h:mm:ss a')}
                        </div>
                      </div>
                      :
                      null}
                  </div>)
              })}
          </div>
          {data && index < (data.length -1) && <div className='bb1-s-lightgray hide-tablet pt10 mb10'/>}  
        </div>
      )
      return mappedArrayEntry      
    })
   
    return (
      <div className='df mt10 mb10'>
        <div className='w100%'>
          {cardContent}
        </div>
      </div>
    )
  }

  let content = status ? <TableStatus status={status} /> : null
  if (!content && data.length) {
    content = (
      renderSignersAndApprovers()
    )
  }

  return (
    <Widget title={'Signers'} dataTestId={'signersWidget'} button={button}>
      {content}
    </Widget>
  )
}

export default withRouter(SignersAndApprovers)

